export const getYesNoAnswer = (payload: { yes: boolean }) => {
  return payload.yes ? 'Да' : 'Нет'
}
